<script setup lang="ts">
import { Head, router, usePage } from "@inertiajs/vue3";
import { ShareIcon } from "lucide-vue-next";
import { computed, ref } from "vue";

import { Button } from "@/components/ui/button";
import { organizationDiscussionThreadsPath } from "@/routes";

interface Props {
  shared_title?: string;
  shared_text?: string;
  shared_url?: string;
}

defineProps<Props>();
const page = usePage<{ auth?: { organization?: { id: number } } }>();
const organizationId = computed(() => page.props.auth?.organization?.id);

const isRedirecting = ref(false);

const goToThreads = () => {
  if (!organizationId.value) return;
  isRedirecting.value = true;
  router.visit(organizationDiscussionThreadsPath(organizationId.value));
};
</script>

<template>
  <Head title="Contenido compartido" />

  <div class="mx-auto max-w-lg space-y-6 py-8">
    <div class="flex items-center gap-3">
      <div class="flex size-10 items-center justify-center rounded-full bg-primary/10">
        <ShareIcon class="size-5 text-primary" />
      </div>
      <div>
        <h1 class="text-lg font-semibold">Contenido compartido</h1>
        <p class="text-sm text-muted-foreground">
          Se recibió contenido desde otra app
        </p>
      </div>
    </div>

    <div class="space-y-3 rounded-xl border border-border/60 bg-card p-4">
      <div v-if="shared_title">
        <span class="text-xs font-medium text-muted-foreground">Título</span>
        <p class="text-sm">{{ shared_title }}</p>
      </div>
      <div v-if="shared_text">
        <span class="text-xs font-medium text-muted-foreground">Texto</span>
        <p class="whitespace-pre-wrap text-sm">{{ shared_text }}</p>
      </div>
      <div v-if="shared_url">
        <span class="text-xs font-medium text-muted-foreground">URL</span>
        <p class="text-sm break-all text-primary">{{ shared_url }}</p>
      </div>
    </div>

    <div class="flex gap-2">
      <Button class="flex-1" @click="goToThreads" :disabled="isRedirecting || !organizationId">
        Ir a Hilos
      </Button>
    </div>

    <p class="text-center text-xs text-muted-foreground">
      Puedes copiar el contenido de arriba y pegarlo en cualquier hilo.
    </p>
  </div>
</template>
